import {AttributeType} from "../../../../integration/datacatalog/datacatalog-services";

export class AttributeValueValidator {
    static validate(attributeType: AttributeType, value: string): ValidationResult {
        const fieldLength = attributeType.fieldLength;
        if (attributeType.valueType + '' == 'NUMBER') {
            let validationResult = AttributeValueValidator.validateNumberFormat(value);
            if (validationResult.isValid) {
                const toValidate = value.indexOf('-') === 0 ? value.substring(1) : value; // remove «-»
                validationResult = AttributeValueValidator.validateFieldLength(fieldLength, toValidate);
                if (validationResult.isValid) {
                    validationResult = AttributeValueValidator.validateNumDecimals(attributeType.numDecimals, toValidate);
                }
            }
            return validationResult;
        } else if (attributeType.valueType + '' === 'STRING') {
            return AttributeValueValidator.validateFieldLength(fieldLength, value);
        } else {
            return new ValidationResult(true);
        }
    }

    private static validateNumberFormat(value: string): ValidationResult {
        const number = value.trim();
        if (number.length > 0) {
            const valid = /^(-(?=.))?\d*(\.\d+)?$/.test(number);
            if (!valid) {
                return new ValidationResult(false, 'Ugyldig tall');
            }
        }
        return new ValidationResult(true);
    }

    private static validateFieldLength(fieldLength: number, value: string): ValidationResult{
        if (fieldLength && value.length > fieldLength) {
            return new ValidationResult(false, 'For stor feltbredde (max ' + fieldLength + ')');
        } else {
            return new ValidationResult(true);
        }
    }

    private static validateNumDecimals(numDecimals: number, value: string): ValidationResult {
        if (numDecimals !== undefined) {
            const decimalStart = value.indexOf('.');
            if (decimalStart !== -1 && value.substring(decimalStart + 1).length > numDecimals) {
                return new ValidationResult(false, 'For mange desimaler (maks ' + numDecimals + ')');
            }
        }
        return new ValidationResult(true);
    }
}

export class ValidationResult {
    constructor(public isValid: boolean, public message: string = ''){}
}
